
export type FeatureAItem = {
  title: string;
  desc: string;
  imageSrc: string;
  alt: string;
  gradientClass: string;
  iconName: string;
  badges?: string[];
};

const featuresA: FeatureAItem[] = [
  {
    title: '智慧邀請函管理',
    desc: '不用再一個一個打電話問「你來不來」，發連結就搞定，回覆自動統計',
    imageSrc: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=400&h=250&fit=crop&crop=center',
    alt: '婚禮邀請函設計',
    gradientClass: 'from-pink-100 to-rose-100',
    iconName: 'Mail',
    badges: ['自動化流程', '即時統計'],
  },
  {
    title: '直覺式座位安排',
    desc: '不用再為了「誰跟誰不能坐一起」煩惱，拖拉就排好，自動算人數',
    imageSrc: 'https://images.unsplash.com/photo-1469371670807-013ccf25f16a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: '座位安排',
    gradientClass: 'from-rose-100 to-pink-50',
    iconName: 'Users',
    badges: ['可視化操作', '智能提醒'],
  },
  {
    title: '視覺化時間軸',
    desc: '再也不會突然想到「啊！忘記訂花了」，時間軸幫你記住每一件事',
    imageSrc: 'https://images.unsplash.com/photo-1507504031003-b417219a0fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: '時間軸規劃',
    gradientClass: 'from-amber-100 to-yellow-50',
    iconName: 'GanttChartSquare',
    badges: ['進度追蹤', '團隊協作'],
  },
  {
    title: '預算與紅包管理',
    desc: '錢花去哪了？紅包收了多少？一目瞭然，不用再翻 Excel 對帳',
    imageSrc: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: '預算管理',
    gradientClass: 'from-pink-50 to-rose-100',
    iconName: 'Gift',
    badges: ['分類管理', '匯出報表'],
  },
  {
    title: '賓客關係管理',
    desc: '男方幾桌、女方幾桌、誰吃素、誰帶小孩，所有資訊一個地方管',
    imageSrc: 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=400&h=250&fit=crop&crop=center',
    alt: '賓客管理',
    gradientClass: 'from-rose-50 to-pink-100',
    iconName: 'ClipboardList',
    badges: ['智能分類', '即時更新'],
  },
  {
    title: '婚禮網站製作',
    desc: '一個美美的婚禮頁面，把你們的故事分享給親友，取代散落的訊息',
    imageSrc: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: '婚禮網站',
    gradientClass: 'from-rose-100 to-pink-100',
    iconName: 'Heart',
    badges: ['精美範本', '故事分享'],
  },
];

export type SocialPostItem = {
  avatarSrc: string;
  name: string;
  meta: string;
  content: string;
  highlightText?: string;
  highlightClassName?: string;
  likes: number;
  comments: number;
};

const socialPostsA: SocialPostItem[] = [
  {
    avatarSrc: 'https://i.pravatar.cc/150?u=user1',
    name: '小雯',
    meta: '2小時前 • 婚禮籌備中',
    content: '"終於找到理想的婚紗攝影師了！感謝社群裡大家的推薦，特別是 @Jessica 分享的經驗貼，讓我少走了很多彎路 ❤️"',
    likes: 24,
    comments: 8,
  },
  {
    avatarSrc: 'https://i.pravatar.cc/150?u=user2',
    name: '阿哲',
    meta: '5小時前 • 30天後結婚',
    content: '"座位安排功能真的太讚了！原本還在煩惱25桌要怎麼排，結果用拖拉的方式十分鐘就搞定了，賓客分組也超方便！"',
    likes: 18,
    comments: 12,
  },
  {
    avatarSrc: 'https://i.pravatar.cc/150?u=user3',
    name: '婷婷',
    meta: '1天前 • 剛完成婚禮',
    content: '"婚禮圓滿落幕！感謝這個平台幫我們省下至少50小時的煩惱時間，從邀請函設計到座位安排都超順暢 🎉"',
    highlightText: '💡 小提醒：記得提前一週發送桌號通知給賓客，大家會很感謝你！',
    highlightClassName: 'bg-gradient-to-r from-pink-100 to-rose-100',
    likes: 32,
    comments: 15,
  },
];

export type StepItem = {
  imageSrc: string;
  alt: string;
  title: string;
  text: string;
};

const stepsA: StepItem[] = [
  {
    imageSrc: '/images/couple-walking-2.png',
    alt: 'Create Your Wedding',
    title: '1. 建立邀請函',
    text: '填入婚禮資訊，5 分鐘內生成你的專屬邀請頁面',
  },
  {
    imageSrc: '/images/couple-toasting-1.png',
    alt: 'Send Invitations',
    title: '2. 一鍵發送，即時追蹤',
    text: '把連結傳給親友，誰回覆了、誰留言了，全部即時看到',
  },
  {
    imageSrc: '/images/venue-1.png',
    alt: 'Manage Guests & Seating',
    title: '3. 搞定座位和預算',
    text: '拖拉排座位、追蹤紅包、管理預算，剩下的瑣事也一次處理',
  },
];

// Generic aliases for the primary landing version
export const features = featuresA;
export const socialPosts = socialPostsA;
export const steps = stepsA;

export type TestimonialItem = {
  imageSrc: string;
  imageAlt: string;
  badgeText: string;
  badgeColorClass: string; // e.g. 'bg-green-500'
  avatarSrc: string;
  name: string;
  locationDate: string;
  metric: string;
  quote: string;
};

export const testimonials: TestimonialItem[] = [
  {
    imageSrc: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&h=300&fit=crop&crop=center',
    imageAlt: '婚禮現場',
    badgeText: '座位安排',
    badgeColorClass: 'bg-wedding-pink',
    avatarSrc: 'https://i.pravatar.cc/150?u=story1',
    name: 'Jessica & Mike',
    locationDate: '台北 • 2025年12月',
    metric: '120 位賓客',
    quote: '"光是排座位就排了三個晚上，後來用這個十分鐘就搞定，早知道就不要自己硬排了。"',
  },
  {
    imageSrc: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=300&fit=crop&crop=center',
    imageAlt: '婚宴場地',
    badgeText: '座位安排',
    badgeColorClass: 'bg-wedding-pink',
    avatarSrc: 'https://i.pravatar.cc/150?u=story2',
    name: 'Emily & David',
    locationDate: '台中 • 2025年10月',
    metric: '25 桌',
    quote: '"25桌真的是噩夢等級，誰跟誰不能坐、誰要靠近舞台，用拖的就好，比用 Excel 快太多了。"',
  },
  {
    imageSrc: 'https://images.unsplash.com/photo-1507504031003-b417219a0fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    imageAlt: '婚禮籌備',
    badgeText: '時間軸',
    badgeColorClass: 'bg-pink-400',
    avatarSrc: 'https://i.pravatar.cc/150?u=story3',
    name: '陳先生 & 黃小姐',
    locationDate: '高雄 • 2026年1月',
    metric: '零遺漏完成籌備',
    quote: '"差點忘記訂婚禮小物，還好時間軸有提醒。籌備期間最怕就是漏掉什麼，這個真的救了我。"',
  },
  {
    imageSrc: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=400&h=300&fit=crop&crop=center',
    imageAlt: '預算管理',
    badgeText: '預算管理',
    badgeColorClass: 'bg-rose-400',
    avatarSrc: 'https://i.pravatar.cc/150?u=story4',
    name: '林小姐 & 王先生',
    locationDate: '新竹 • 2025年11月',
    metric: '預算沒有爆',
    quote: '"婚禮最怕花超過預算，這邊每筆花費都記得清清楚楚，老公也不用一直問我錢花去哪了。"',
  },
  {
    imageSrc: 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=400&h=400&fit=crop&crop=center',
    imageAlt: '賓客管理',
    badgeText: 'RSVP 追蹤',
    badgeColorClass: 'bg-pink-500',
    avatarSrc: 'https://i.pravatar.cc/150?u=story5',
    name: '張小姐 & 李先生',
    locationDate: '台南 • 2025年9月',
    metric: 'RSVP 回覆率 95%',
    quote: '"以前都要一個一個打電話問來不來，現在發個連結就好，誰還沒回覆一看就知道，超省事。"',
  },
  {
    imageSrc: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    imageAlt: '紅包管理',
    badgeText: '紅包統計',
    badgeColorClass: 'bg-rose-500',
    avatarSrc: 'https://i.pravatar.cc/150?u=story6',
    name: '黃小姐 & 陳先生',
    locationDate: '桃園 • 2025年8月',
    metric: '紅包帳目清清楚楚',
    quote: '"婚禮當天收紅包收到手軟，事後要對帳超崩潰。還好有紅包統計功能，誰包多少全部自動記好。"',
  },
];
